import { useContext, useMemo } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { AuthContext } from '../contexts/AuthContext'
import { SettingContext } from '../contexts/SettingContext'
import { DATATYPE_DOSE, TITLE } from '../databases/spName'
import { DateForm, SelectForm } from './FormItem'

const RenderEditForm = props => {
    const { value, onEdit, onChange, field, isAdminEdit, doseTaken, setClearDose } = props
    const { disabledHiddenList } = useContext(SettingContext)
    const { owndata } = useContext(AuthContext)
    const { round } = owndata

    const isHiddenList = useMemo(() => disabledHiddenList[(round || 0)][field]?.hidden, [disabledHiddenList, field, round])
    const isDisabledList = useMemo(() => disabledHiddenList[(round || 0)][field]?.disabled, [disabledHiddenList, field, round])

    const shownValue = useMemo(() => {
        return TITLE[field].options ? (TITLE[field].options[value] || value) : value
    }, [field, value])

    const isHidden = useMemo(() => {
        return isAdminEdit ? false 
            : ['role', 'email'].includes(field) ? true 
            : ['round', 'register'].includes(field) === field ? false 
            : TITLE[field].datatype === DATATYPE_DOSE && field !== 'dose' && !isNaN(field.charAt(4)) && parseInt(field.charAt(4)) > doseTaken ? true
            : isHiddenList || false
    }, [field, isAdminEdit, isHiddenList, doseTaken])

    const isDisabled = useMemo(() => {
        return isAdminEdit ? false : ['round', 'role', 'email', 'register'].includes(field) ? true : isDisabledList || false
    }, [field, isAdminEdit, isDisabledList])

    const SwitchFormType = () => {
        if (field === 'dose') {
            return (
                <SelectForm 
                    noMargin={true} 
                    value={value} onChange={e => setClearDose(e.target.value)} 
                    options={TITLE[field].options} 
                    disabled={isDisabled}
                />
            )
        }
        else if (TITLE[field].options) {
            return (
                <SelectForm 
                    noMargin={true} 
                    value={value} onChange={onChange} 
                    options={TITLE[field].options} 
                    disabled={isDisabled}
                />
            )
        }
        else if (TITLE[field].isUppercase) {
            return (
                <Form.Control value={value} onChange={onChange} disabled={isDisabled} style={{textTransform : 'uppercase'}}/>
            )
        }
        else if (TITLE[field].isDate) {
            return (
                <DateForm noMargin={true} value={value} onChange={onChange} disabled={isDisabled} />
            )
        }
        else {
            return (
                <Form.Control value={value} onChange={onChange} disabled={isDisabled} />
            )
        }
    }

    return (
        <div style={{marginTop : '-12px'}} hidden={isHidden}>
            <Form.Group>
                <Row bsPrefix="row align-items-center">
                    <Col bsPrefix="col-sm-6 d-none d-sm-block">
                        <div className="bold">{TITLE[field].TH || ''}</div>
                        <div className="bold">{TITLE[field].CN || ''}</div>
                    </Col>
                    <Col bsPrefix="col-xs-12 d-block d-sm-none">
                        <div className="bold">{`${TITLE[field].TH} / ${TITLE[field].CN}`}</div>
                    </Col>
                    <Col>
                        {onEdit ? SwitchFormType() : <div>{shownValue}</div>}
                    </Col>
                </Row>
            </Form.Group>
            <hr style={{marginTop : '5px'}}/>
        </div>
    )
}

export default RenderEditForm;